export const parseLicenseKeyCsv = (csvContent) => {
  const lines = csvContent.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  const result = [];

  for (const line of lines) {
    // Remove dashes and normalize
    const key = line.trim().toUpperCase().replace(/-/g, "");

    // Basic validation: should be 20 characters (typical license key length)
    if (key.length === 20) {
      const segments = key.match(/.{1,5}/g);
      result.push({
        keySegments: segments,
        credits: "-",
        status: "Pending", // For UploadView status column
      });
    }
  }

  return result;
};

export const toJSON = (formValue) => {
  return {
    data: {
      licenseKeys: formValue.licenseKeys
        .map(item => item.keySegments.join("-"))
        .filter(key => key.replace(/-/g, "").length === 20),
    }
  };
};
